import { Flex, Text } from '@chakra-ui/react'
import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { useUser } from 'src/context/userContext'
import { SupportedDescriptionSection } from './components/DescriptionLandingPage'
import { SupportedFooter } from './components/FooterLandingPage'
import { SupportedKnowMore } from './components/KnowMore'
import { Steps } from './components/Steps'

const Supported: React.FC = () => {
  const [t] = useTranslation()
  const { user } = useUser()

  useEffect(() => {
    if (!user) return
  }, [user])

  return (
    <Flex flexDirection='column' bg='white' justifyContent='center' alignItems='center' w='100%'>
      <Helmet>
        <title>{t('common.Add Extension')} | Education Journey</title>
      </Helmet>
      <SupportedDescriptionSection />
      <Steps />
      <Text fontFamily='Poppins' fontSize='28px' fontWeight='bold' marginBottom='19px' marginTop='37px'>
        {t('onboard.success.desktop.thirdSection.title')}
      </Text>
      <SupportedKnowMore />
      <SupportedFooter />
    </Flex>
  )
}

export default Supported
